/**
 * Minimalistic (naive) deep clone that omits non-serializable values (e.g., functions, undefined, symbols, circular references).
 *
 * If the object is not serializable as a whole, it will throw away whole 1st-level properties that are not serializable.
 *
 * NOTE: this function is optimized for the size (character count) rather than performance or completeness.
 */
function tryClone<T>(obj: T): T | undefined {
  try {
    return JSON.parse(JSON.stringify(obj))
  } catch {
    // Omit non-serializable values
  }
}

export function cloneAsc<T>(obj: T): Partial<T> {
  if (!obj) return obj
  const whole = tryClone(obj)
  if (whole) return whole

  const entries = Object.entries(obj || {}).map(([key, value]) => [key, tryClone(value)])
  return Object.fromEntries(entries)
}
